export default __webpack_public_path__ + "static/media/Snapchat.9152cfc5.PNG";